import { render, staticRenderFns } from "./CreditBetween.vue?vue&type=template&id=070e8762&"
import script from "./CreditBetween.vue?vue&type=script&lang=js&"
export * from "./CreditBetween.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports